<script>

export default {
  name: "CreateTicket",
  data() {
    return {
      user: {
        name : '',
        email : ''
      },
      ticket: {
        id_department : '',
        id_location : '',
        id_ticket_cat : '',
        description : '',
      },
      ticket_scalable: {
        justification : '',
      },
      department : [],
      location : [],
      ticket_cat : [],
      escalation : ["Si","No"],
      selectedDepartmentTitle: '',
      selectedCategoryName: '',
      selectedLocationName: '',

    }
  },
  methods: {
    getIDDepartment() {
      let selectedItem = this.departments.find(department => department.title === this.selectedDepartmentTitle);
      if (selectedItem !== undefined) {
        this.ticket.id_department = selectedItem.id
      }
    },
    getIDLocation() {
      let selectedItem = this.location.find(location => location.name === this.selectedCategoryName);
      if (selectedItem !== undefined) {
        this.ticket.id_department = selectedItem.id
      }
    },
  }
}
</script>

<template>
  <div id="section-0" class="container">

    <div class="form-reg-user">
      <h1>Crear ticket</h1>
      <form class="Form">

        <div class="grid-container">

          <div>
            <label>Nombre</label>
            <input type="text" v-model="user.name" placeholder="Nombres" maxlength="70">
          </div>

          <div>
            <label>Correo</label>
            <input type="text" v-model="user.email" placeholder="Correo electronico" maxlength="70">
          </div>

          <div>
            <label>Departamento</label>
            <input list="department" v-model="selectedDepartmentTitle" @input="getIDDepartment" maxlength="250">
            <datalist id="department">
              <option v-for="dep in department" :key="dep.id" :value="dep.title"></option>
            </datalist>
          </div>

          <div>
            <label>Ubicacion</label>
            <input list="location" v-model="selectedLocationName" @input="getIDLocation" maxlength="250">
            <datalist id="location">
              <option v-for="loc in location" :key="loc.id" :value="loc.name"></option>
            </datalist>
          </div>

          <div>
            <label>Categoria</label>
            <input list="ticket_cat" v-model="selectedCategoryName" @input="getIDCategory" maxlength="250">
            <datalist id="ticket_cat">
              <option v-for="cat in ticket_cat" :key="cat.id" :value="cat.name"></option>
            </datalist>
          </div>

          <div>
            <label>Escalar</label>
            <select v-model="ticket_scalable.scalable">
              <option disabled value="">Seleccione una opción</option>
              <option value="si">Sí</option>
              <option value="no">No</option>
            </select>
          </div>

        </div>

        <div>
          <label style="text-align: center ;">Justificacion</label>
          <textarea v-model="ticket_scalable.justification" style="height: 65px; width: 702px;" placeholder="Justificacion" maxlength="250"></textarea>
        </div>

        <div>
          <label style="text-align: center ;">Descripcion</label>
          <textarea v-model="ticket.description" style="height: 65px; width: 702px;" placeholder="Descripcion" maxlength="250"></textarea>
        </div>





      </form>
    </div>



  </div>

</template>

<style scoped>

</style>